/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Allocated_ToInputs */

const en_admin_resources_resource_allocations_allocated_to = /** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocated to`)
};

const de_admin_resources_resource_allocations_allocated_to = /** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesen an`)
};

const es_admin_resources_resource_allocations_allocated_to = /** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignado a`)
};

const fr_admin_resources_resource_allocations_allocated_to = /** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribué à`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_allocated_to = en_admin_resources_resource_allocations_allocated_to;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_allocated_to = en_admin_resources_resource_allocations_allocated_to;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_allocated_to = en_admin_resources_resource_allocations_allocated_to;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_allocated_to = en_admin_resources_resource_allocations_allocated_to;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Allocated_ToInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_allocated_to = en_admin_resources_resource_allocations_allocated_to;

/**
* | output |
* | --- |
* | "Allocated to" |
*
* @param {Admin_Resources_Resource_Allocations_Allocated_ToInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_allocated_to = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Allocated_ToInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Allocated_ToInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_allocated_to(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_allocated_to(inputs)
	return ro_admin_resources_resource_allocations_allocated_to(inputs)
});
export { admin_resources_resource_allocations_allocated_to as "admin.resources.resource_allocations.allocated_to" }